import { jsxs as H, jsx as i } from "react/jsx-runtime";
import { useReducer as k, useEffect as d } from "react";
import { TrailerRentalReducer as w, InitialTrailerRentalState as W } from "../../../state/trailer-rental-reducer.js";
import { Drawer as x } from "../../../../../components/elements/drawer/drawer.js";
import { SelectTimeSlotAndPersonalInfo as P } from "../../elements/select-time-slot-and-personal-info/select-time-slot-and-personal-info.js";
import { BookingCompleted as V } from "../../elements/booking-completed/booking-completed.js";
import M from "../../elements/trailer-rental-search-widget/trailer-rental-search-widget.js";
import { useGetTrailerRentalLocationsQuery as j } from "../../../react-query-queries/use-get-trailer-rental-locations.js";
import { useGetTrailerAvailability as K } from "../../../react-query-queries/use-get-trailer-availability.js";
import { isArrayWithItems as Q } from "../../../../../helpers/array-helper.js";
import { ListAvailableTrailers as U } from "../../elements/list-available-trailers/list-available-trailers.js";
import { sortBy as q } from "lodash-es";
import l from "dayjs";
import { dayjsToDateString as c } from "../../../../../helpers/date-helper.js";
import { filterStationsByNearbyStation as y, separateNearbyTrailersFromSelectedStation as z, extendNearbyTrailersWithInfo as J } from "../../../helpers/trailer-rental-helper.js";
import X from "../../../../../events/event-aggregator.js";
import { EVENT as Y } from "../../../../../events/event.js";
const Ae = ({
  step: S = "SHOW_SEARCH_WIDGET",
  title: A,
  textStepOne: I,
  textStepTwo: f,
  rentalTermsLinkUrl: v,
  bookingConfirmationAdditionalText: D,
  preSelectedStationId: p,
  preSelectedRentalStartDate: T,
  preSelectedRentalEndDate: E
}) => {
  const [e, r] = k(w, {
    ...W,
    step: S,
    selectedRentalStartDate: T ? c(l(T)) : c(l()),
    selectedRentalEndDate: E ? c(l(E)) : c(l())
  }), {
    data: m,
    isLoading: L,
    error: _
  } = j(), u = e.nearbyStations ? e.nearbyStations.map((t) => t.locationId) : [], {
    refetch: g,
    data: n,
    isLoading: h,
    error: N
  } = K({
    from: e.selectedRentalStartDate ? e.selectedRentalStartDate : void 0,
    to: e.selectedRentalEndDate ? e.selectedRentalEndDate : void 0,
    locationIds: e.selectedStation ? [e.selectedStation.locationId, ...u] : void 0
  }), R = () => {
    g(), X.publish(Y.TRACK_EVENT, {
      event: "find_trailer",
      station: e.selectedStation?.name,
      pickup_date: e.selectedRentalStartDate,
      return_date: e.selectedRentalEndDate
    }), r({ type: "CHANGE_STEP", payload: { step: "LIST_AVAILABLE_TRAILERS" } });
  };
  d(() => {
    r({
      type: "CHANGE_STEP",
      payload: { step: S }
    });
  }, [S]), d(() => {
    if (m) {
      const t = q(m, "name"), a = t.find(
        (G) => G.locationId.toString() === p
      ), o = y(t, a);
      r({
        type: "SET_AVAILABLE_STATIONS",
        payload: {
          stations: t,
          selectedStationId: p,
          nearbyStations: o
        }
      });
    }
  }, [m]), d(() => {
    T && E && !e.hasTriggeredAutoSearch && e.availableStations && e.selectedStation && e.nearbyStations && (R(), r({ type: "SET_HAS_TRIGGERED_AUTOSEARCH" }));
  }, [e.hasTriggeredAutoSearch, e.availableStations, e.selectedStation, e.nearbyStations]), d(() => {
    if (e.selectedStation && n?.trailersAvailability && Q(n.trailersAvailability)) {
      const { trailersForStation: t, nearbyTrailers: a } = z(
        n.trailersAvailability,
        e.selectedStation
      ), o = J(
        a,
        e.selectedStation,
        e.nearbyStations
      );
      r({
        type: "SET_AVAILABLE_TRAILERS",
        payload: { trailers: t, nearbyTrailers: o }
      });
    }
  }, [n]);
  const C = () => {
    r({
      type: "DESELECT_TRAILER"
    });
  }, O = (t) => {
    const a = t.target.value;
    t.target.name === "startDate" && r({ type: "SELECT_RENTAL_DATE", payload: { rentalStartDate: a || null } }), t.target.name === "endDate" && r({ type: "SELECT_RENTAL_DATE", payload: { rentalEndDate: a || null } });
  }, F = (t) => {
    if (!e.availableStations)
      return;
    const a = e.availableStations?.find((o) => o.locationId === t);
    if (a) {
      const o = y(e.availableStations, a);
      r({ type: "SELECT_STATION", payload: { station: a, nearbyStations: o } });
    }
  }, s = e.selectedTrailer?.locationId !== e.selectedStation?.locationId ? e.availableStations?.find((t) => t.locationId === e.selectedTrailer?.locationId) : e.selectedStation, B = (t) => {
    switch (t) {
      case "SHOW_SEARCH_WIDGET":
        return /* @__PURE__ */ i(
          M,
          {
            startDate: e.selectedRentalStartDate ? e.selectedRentalStartDate : void 0,
            endDate: e.selectedRentalEndDate ? e.selectedRentalEndDate : void 0,
            setCurrentStation: F,
            currentStation: e.selectedStation,
            onDateChange: O,
            availableStations: e.availableStations,
            onClickSearchButton: R,
            title: A,
            textStepOne: I,
            isLoading: L,
            hasApiError: !!_
          }
        );
      case "LIST_AVAILABLE_TRAILERS":
      case "SELECT_TIMESLOT_FOR_TRAILER":
      case "PERSONAL_INFORMATION":
        return /* @__PURE__ */ i(
          U,
          {
            dispatch: r,
            availableTrailers: e.availableTrailers ? e.availableTrailers : [],
            nearbyAvailableTrailers: e.nearbyAvailableTrailers ? e.nearbyAvailableTrailers : [],
            availableStations: e.availableStations,
            trailerTypeFilter: e.trailerTypeFilter,
            selectedRentalStartDate: l(e.selectedRentalStartDate),
            selectedRentalEndDate: l(e.selectedRentalEndDate),
            selectedStation: e.selectedStation,
            widgetTitle: A,
            widgetText: f,
            isLoading: h,
            hasApiError: !!N
          }
        );
      case "BOOKING_COMPLETED":
        return e.bookingId && e.customerEmail && e.selectedTrailer && s && e.selectedFromSlot && e.selectedToSlot && /* @__PURE__ */ i(
          V,
          {
            bookingId: e.bookingId,
            customerEmail: e.customerEmail,
            station: s,
            trailer: e.selectedTrailer,
            fromSlot: l(e.selectedFromSlot),
            toSlot: l(e.selectedToSlot),
            bookingConfirmationAdditionalText: D
          }
        );
    }
  }, b = e.step === "SELECT_TIMESLOT_FOR_TRAILER" || e.step === "PERSONAL_INFORMATION";
  return /* @__PURE__ */ H("section", { children: [
    B(e.step),
    /* @__PURE__ */ i(x, { isOpen: b, anchor: "bottom", children: b && e.selectedTrailer && s && e.selectedRentalStartDate && e.selectedRentalEndDate && /* @__PURE__ */ i(
      P,
      {
        step: e.step,
        dispatch: r,
        closeDrawer: C,
        selectedTrailer: e.selectedTrailer,
        selectedStation: s,
        selectedRentalStartDate: l(e.selectedRentalStartDate),
        selectedRentalEndDate: l(e.selectedRentalEndDate),
        selectedFromSlot: e.selectedFromSlot ? l(e.selectedFromSlot) : void 0,
        selectedToSlot: e.selectedToSlot ? l(e.selectedToSlot) : void 0,
        rentalTermsLinkUrl: v,
        personalInformationForm: e.personalInformationForm
      }
    ) })
  ] });
};
export {
  Ae as TrailerRentalBlock,
  Ae as default
};
